module.exports = __webpack_public_path__ + "img/251.welcome_you.a9395720.svg";